import React from 'react'
import { Button, Icon, Modal, Transition } from 'semantic-ui-react'

function confirmReducer(state, action) {
    switch (action.type) {
        case 'close':
            return { open: false }
        case 'open':
            return { open: true, size: action.size }
        default:
            throw new Error('Unsupported action...')
    }
}

const ConfirmModal = (props) => {
    const [state, dispatch] = React.useReducer(confirmReducer, {
        open: false,
        size: undefined,
    })
    // console.log(props.data);
    return (
        <>
            <Transition visible={props.open} animation='zoom' duration={400}>
                <Modal
                    size="mini"
                    open={props.open}
                    style={{ borderRadius: 0 }}
                >
                    <Modal.Header>{props.header}</Modal.Header>
                    <Modal.Content>
                        <p>{props.content}</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            negative
                            onClick={props.onCancel}
                            style={{ borderRadius: 0 }}>
                            No
                        </Button>
                        <Button
                            loading={props.loading}
                            type="submit"
                            style={{ borderRadius: 0 }}
                            positive
                            onClick={props.onConfirm}>
                            Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
            </Transition>
        </>
    )
}

export default ConfirmModal